
import { de } from 'date-fns/locale'
import { parseISO, parse, format } from 'date-fns';
const i18n = { locale: de };


export const simpleFormat = (date, formatSyntax) => {
  if(formatSyntax === undefined) formatSyntax = 'dd.MM.yyyy';
  return format(date, formatSyntax, { locale: getDateFnsLocale() });
}

export const simpleParse = (dateString, parseSyntax) => {
  if(parseSyntax === undefined) parseSyntax = 'yyyy-MM-dd';
  return parse(dateString, parseSyntax, new Date(2000, 1, 1));
}

export const getDateFnsLocale = () => {
  return i18n.locale;
}

export const doParseAndFormat = (value, parseSyntax, formatSyntax) => {
  let parsed = null;
  if(parseSyntax==='iso') {
    parsed = parseISO(value);
  } else {
    parsed = parse(value, parseSyntax, new Date(2000, 1, 1));
  }
  if(formatSyntax === undefined) formatSyntax = 'dd.MM.yyyy';
  return value ? format( parsed, formatSyntax, { locale: getDateFnsLocale() } ) : '';
}

/**
 * Will transform a date string from the format 'yyyy-MM-dd' to 'dd.MM.yyyy'
 * @param {string|null} value
 * @returns {string|null} formatted date string in 'dd.MM.yyyy' format or null if parsing fails
 */
export const dateFormatFromDB = (value) => {
  try {
    return doParseAndFormat(value, 'yyyy-MM-dd', 'dd.MM.yyyy');
  } catch(e) {
    return null;
  }
}

/**
 * Will transform a date string from the format 'yyyy-MM-dd' to 'dd.MM.yyyy'
 * @param {string|null} value
 * @returns {string|null} formatted date string in 'dd.MM.yyyy' format or null if parsing fails
 */
export const dateTimeFormatFromDB = (value) => {
  try {
    return doParseAndFormat(value, 'iso', 'dd.MM.yyyy HH:mm');
  } catch(e) {
    return null;
  }
}

/**
 * Will transform a date string from the format 'dd.MM.yyyy' to 'yyyy-MM-dd'
 * @param {string|null} value
 * @returns {string} empty string or formatted date string in 'yyyy-MM-dd' format
 */
export const dateFormatToDB = (value) => {
  if(!value || value === '' || typeof value !== 'string') return '';
  try {
    return doParseAndFormat(value, 'dd.MM.yyyy', 'yyyy-MM-dd');
  } catch(e) {
    return '';
  }
}


export const dateFromDateComponent = (value) => {
  if(!value || value === '' || typeof value !== 'string') return '';
  try {
    return doParseAndFormat(value, 'yyyy-MM-dd', 'dd.MM.yyyy');
  } catch(e) {
    return '';
  }
}

export const fixDateInput = (inputEvent) => {
  if(inputEvent.target.value) {
    let splitted = inputEvent.target.value.split('.');
    if(splitted.length !== 3) return null;
    splitted[2] = parseInt(splitted[2], 10);
    if(splitted[2] < 100) {
      // if year is two digits and is larger than current year assume its 1900s else assume 2000s
      const currentYear = new Date().getFullYear();
      if(splitted[2] > currentYear % 100) {
        splitted[2] = 1900 + splitted[2];
      } else {
        splitted[2] = 2000 + splitted[2];
      }
    }
    const date = new Date(splitted[2], splitted[1]-1, splitted[0]); // year, month (0-11), day

    if(!isNaN(date.getTime())) {
      inputEvent.target.value = format(date, 'dd.MM.yyyy');
      inputEvent.target.dispatchEvent(new Event('input'));// trigger vue update on input
      return inputEvent.target.value;
    }
  }
  return null;
}


